/** Must match `LanguageSelector` option values (display strings). */
export const DEFAULT_PANEL_LANGUAGE = 'English (EN)';

export const PANEL_LANGUAGE_LABELS = [
  'English (EN)',
  'Spanish',
  'Mandarin Chinese',
  'Arabic',
  'French',
  'Hindi',
  'Portuguese',
  'Russian',
  'Bengali',
  'German',
  'Japanese',
  'Korean',
  'Italian',
];

const LABEL_TO_I18N = {
  'English (EN)': 'en',
  Spanish: 'es',
  'Mandarin Chinese': 'zh-CN',
  Arabic: 'ar',
  French: 'fr',
  Hindi: 'hi',
  Portuguese: 'pt',
  Russian: 'ru',
  Bengali: 'bn',
  German: 'de',
  Japanese: 'ja',
  Korean: 'ko',
  Italian: 'it',
};

/** BCP-47-ish codes for `i18next`. */
export function panelLabelToLng(label) {
  const s = typeof label === 'string' ? label.trim() : '';
  return LABEL_TO_I18N[s] || 'en';
}

export function normalizePanelLanguageLabel(label) {
  const s = typeof label === 'string' ? label.trim() : '';
  if (PANEL_LANGUAGE_LABELS.includes(s)) return s;
  return DEFAULT_PANEL_LANGUAGE;
}

export const PANEL_RTL_LANGS = new Set(['ar']);

export const LS_USER_PANEL_LANG = 'mineme-user-preferredLanguage';
export const LS_AGENT_PANEL_LANG = 'mineme-agent-preferredLanguage';

export const EVENT_PANEL_LANG_SYNC = 'mineme-panel-lang-sync';
